// standalone pages are used by external parties in order to render these in an iframe
const standAlonePages = ['/searchbox', '/planner', '/embed/search', '/embed/searchbox', '/embed/planner'];

export default standAlonePages;
